import {AxiosError} from "axios"
import {waitPromise} from "@irati/utils/promise"
import {PLATFORM} from "@irati-web/app/src/routeConfig"
import History from "../../../../history"
import isMaintenance from "./isMaintenance"

export default function (err: AxiosError) {
  if (isMaintenance(err)) {
    waitPromise()
      .then(() => {
        History.push({
          pathname: "/maintenance",
          app: PLATFORM
        })
      })
      .catch((e) => console.log(e))
  }
}
